import React from 'react';
import ProtectedRoute from '../../components/ProtectedRoute/ProtectedRoute';
import CustomQuizGeneratorPage from '../../features/custom-quiz-generator/components/CustomQuizGeneratorPage';

export default function CustomQuizGeneratorRoute() {
  return (
    <ProtectedRoute>
      <CustomQuizGeneratorPage />
    </ProtectedRoute>
  );
}
